import { apiService } from './api';

/** Roles that can be invited via the magic-link flow.
 *
 * Includes ``h2okay_admin`` — only admins themselves can issue admin
 * invites; the backend enforces who-can-invite-whom rules. Other roles
 * still see a narrower picker on the form per role.
 */
export type InvitableRole =
  | 'h2okay_admin'
  | 'consultant'
  | 'client'
  | 'facility_manager';

export interface Invite {
  id: string;
  email: string;
  role: InvitableRole;
  client_id?: string;
  consultancy_id?: string | null;
  invited_by_id: string;
  redeemed_at?: string | null;
  created_at: string;
  /** Pre-created ``users`` row id, populated by the backend so the
   * frontend can immediately offer "Act as" without a follow-up
   * query. Null only on legacy invites that pre-date this feature. */
  user_id?: string | null;
}

export interface InviteCreate {
  email: string;
  role: InvitableRole;
  client_id?: string;
  /** Required when admin invites a consultant; ignored otherwise. */
  consultancy_id?: string;
}

export class InvitesService {
  list(): Promise<Invite[]> {
    return apiService.get<Invite[]>('/invites/');
  }
  create(payload: InviteCreate): Promise<Invite> {
    return apiService.post<Invite>('/invites/', payload);
  }
  revoke(id: string): Promise<void> {
    return apiService.delete<void>(`/invites/${id}`);
  }
}

export const invitesService = new InvitesService();
